import { useContext, useMemo } from 'react';

import { PercentIcon } from '@smartshell/ui-kit';
import cn from 'classnames';
import { Column } from 'react-table';

import { useWindowResize } from 'hooks';
import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';
import { TService } from 'types';

import s from './UseGetColumns.module.scss';

export const UseGetColumns = (): Column<TService>[] => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { currency },
    },
  } = useContext(SettingsContext);
  const size = useWindowResize();

  return useMemo(() => {
    const columns: Column<TService>[] = [
      {
        Header: t('title'),
        accessor: 'title',
        Cell: ({ row }: { row: { original: TService } }) => {
          const { title, use_global_discounts } = row.original;

          if (size.width > 960) {
            return title;
          } else {
            return (
              <div className={s.mobile_block}>
                <span className={s.title}>{title}</span>
                <span
                  className={cn(s.discount, use_global_discounts && s.active)}
                >
                  <PercentIcon
                    size={'s'}
                    color={use_global_discounts ? 'link-info' : 'secondary'}
                  />
                </span>
              </div>
            );
          }
        },
        width: 180,
      },
    ];

    if (size.width > 960) {
      columns.push({
        Header: t('discount'),
        accessor: 'use_global_discounts',
        Cell: ({ value }: { value: boolean }) => {
          return (
            <div
              className={cn(s.column_category_block, value && s.active_block)}
            >
              <span className={cn(s.text, value && s.active)}>
                {value ? t('discount.applies') : t('discount.applies.no')}
              </span>
            </div>
          );
        },
        width: 145,
        sortType: (rowA, rowB) => {
          const a = rowA.original.use_global_discounts;
          const b = rowB.original.use_global_discounts;
          return a === b ? 0 : a ? -1 : 1;
        },
      });
    }

    columns.push({
      Header: t('cost'),
      Cell: ({ value }: { value: number }) =>
        `${value.toLocaleString()} ${currency.sign}`,
      accessor: 'cost',
    });

    return columns;
  }, [t, size, currency.sign]);
};
